import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useGenericDrawer } from "../../../hooks/drawer/useGenericDrawer";
import { SwitchPaymentModeOptions } from "../SwitchPaymentModeOptions";

// const Right = styled(Space)`
//   display: flex;
//   flex-direction: column
//   align-items: flex-end;
// `;

type SwitchPaymentModeDrawerProps = {
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;
  user: any;
};

export const SwitchPaymentModeDrawer: React.FC<SwitchPaymentModeDrawerProps> = ({
  isDrawerOpen,
  setDrawerOpen,
  user,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer
      title={t("users.actions.switch_payment_mode.title")}
      placement="right"
      width={600}
      closable={true}
      onClose={() => setDrawerOpen(false)}
      open={isDrawerOpen}
      bodyStyle={{ padding: "32px" }}
    >
      {isDrawerOpen && (
        <SwitchPaymentModeOptions

          onCloseDrawer={setDrawerOpen}
          user={user}
        />
      )}
    </Drawer>
  );
};
